import { getSessionStorageItem, getLocalStorageItem, saveSessionStorageItem, saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
export const POPUP_DISPLAYED = 'PopupDisplayed';
// The different types of popups - add new popup here.
export var PopupType = /*#__PURE__*/ function(PopupType) {
    PopupType["LinkedinTeachingBubble"] = "LinkedinTeachingBubble";
    return PopupType;
}({});
// Map used to define the display logic for each popup.
const popups = new Map([
    [
        "LinkedinTeachingBubble",
        {
            maxDisplayCount: 5,
            DisplayOnceInSession: true
        }
    ]
]);
function getTotalDisplayCount(popupType) {
    const storageDisplayCount = getLocalStorageItem(popupType);
    return storageDisplayCount ? parseInt(storageDisplayCount) : 0;
}
function didPopupDisplayedInThisSession(popupType) {
    const displayedInSession = getSessionStorageItem(popupType);
    return POPUP_DISPLAYED === displayedInSession;
}
function didPopupExceededMaxCount(popupType, displayLogic) {
    return displayLogic.maxDisplayCount <= getTotalDisplayCount(popupType);
}
// True if popup should be displayed according to its display history and display logic.
export function shouldDisplayPopup(popupType) {
    const displayLogic = popups.get(popupType);
    if (displayLogic.DisplayOnceInSession) {
        return !didPopupDisplayedInThisSession(popupType) && !didPopupExceededMaxCount(popupType, displayLogic);
    } else {
        return !didPopupExceededMaxCount(popupType, displayLogic);
    }
}
// Call when popup displayed. This call update the popup's display history.
export function popupDisplayed(popupType) {
    const displayLogic = popups.get(popupType);
    const updatedTotalDisplayCount = getTotalDisplayCount(popupType) + 1;
    if (displayLogic.DisplayOnceInSession) {
        saveSessionStorageItem(popupType, POPUP_DISPLAYED);
    }
    saveLocalStorageItem(popupType, updatedTotalDisplayCount.toString());
}
